
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Administration</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <table class="form-group form-group-sm" *ngIf="competences">
              <thead style="position: sticky;top: 0; height:150px; background-color:grey">
                <tr class="border-bottom">
                  <th>nom</th>
                  <th>descriptionCourte</th>
                  <th>isDisponible</th>
                  <th>type</th>
                  <th>Cout</th>
                  <th>Niveau 1</th>
                  <th>Cout</th>
                  <th>Niveau 2</th>
                  <th>Cout</th>
                  <th>Niveau 3</th>
                </tr>
              </thead>
              <tr *ngFor="let competence of competences" class="border-bottom">
                <td class="border">{{competence.nom}}</td>
                <td class="border">{{competence.descriptionCourte}}</td>
                <td class="border">{{competence.isDisponible}}</td>
                <td class="border">{{getType(competence)}}</td>
                <td class="border">{{competence.niveau1?.cout}}</td>
                <td class="border">{{competence.niveau1?.description}}</td>
                <td class="border">{{competence.niveau2?.cout}}</td>
                <td class="border">{{competence.niveau2?.description}}</td>
                <td class="border">{{competence.niveau3?.cout}}</td>
                <td class="border">{{competence.niveau3?.description}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>